import React, {FC} from "react";

const RandomDataDisclaimer: FC = () => (
    <div style={{color: "lightgrey"}}>
        Disclaimer: Die hier dargestellten Daten sind zufällig, da aktuell keine
        Daten (-analysen) vorliegen.
    </div>
);

export default RandomDataDisclaimer;
